import { RecurringInvoiceRepository } from '../domain/RecurringInvoiceRepository'
import { EXPIRATION_TRANSLATOR } from '@/modules/facturae/domain/RecurringInvoiceContract'
import { RecurringInvoiceEditorScreenData } from '../domain/RecurringInvoiceEditorScreenData'
import { ProductConfigurationRepository, ProductRepository } from '../domain/ProductRepository'
import { FileRepository } from '@/modules/shared/domain/FileRepository'
import { ConfigurationRepository } from '../domain/ConfigurationRepository'
import { InvoiceableRepository } from '../domain/InvoiceableRepository'
import { ExtraAmount, InvoiceLine, Party, Tax, RepresentationData } from '../domain/Invoiceable'


export class RecurringInvoiceEditorComponent {

    recurring_invoice_repository: RecurringInvoiceRepository
    invoiceable_repository: InvoiceableRepository
    product_repository: ProductRepository
    config_repo:ConfigurationRepository
    file_repo:FileRepository
    screen_data: RecurringInvoiceEditorScreenData
    product_config_repo:ProductConfigurationRepository

    expiration_translator = EXPIRATION_TRANSLATOR
    recargo_rates = {0.052:0.21, 0.014:0.1, 0.005:0.04}
    currentCompany: any

    constructor(
        recurring_invoice_repository:RecurringInvoiceRepository,
        invoiceable_repository: InvoiceableRepository,
        product_repository: ProductRepository,
        config_repo:ConfigurationRepository,
        file_repo:FileRepository,
        screen_data:RecurringInvoiceEditorScreenData,
        currentCompany: any,
        product_config_repo: ProductConfigurationRepository
    ) {
        this.recurring_invoice_repository = recurring_invoice_repository
        this.invoiceable_repository = invoiceable_repository
        this.product_repository = product_repository
        this.config_repo = config_repo
        this.file_repo = file_repo
        this.screen_data = screen_data
        this.currentCompany = currentCompany
        this.product_config_repo = product_config_repo
    }

    supplier_from_current_company(currentCompany, company_id) {
            let supplier = new Party({
                id: 0,
                company_id: company_id,
                cif: "",
                post_code: ""
            })
            if (currentCompany && currentCompany.configuration && currentCompany.configuration.company_as_party){
                let cap = currentCompany.configuration.company_as_party
                supplier.business_name = cap.business_name ? cap.business_name : ""
                supplier.trade_name = cap.trade_name ? cap.trade_name : ""
                supplier.name = cap.name ? cap.name : ""
                supplier.first_surname = cap.first_surname ? cap.first_surname : ""
                supplier.second_surname = cap.second_surname ? cap.second_surname : ""
                supplier.type = cap.type
                supplier.cif = cap.cif
                supplier.address = cap.address
                supplier.city = cap.city
                supplier.province = cap.province
                supplier.email = cap.email
                supplier.phone = cap.phone
                supplier.website = cap.website
                supplier.post_code = cap.post_code
                supplier.bank_account_number = cap.bank_account_number
                supplier.bic = cap.bic
                supplier.mandate_id = cap.mandate_id ? cap.mandate_id : ''
                supplier.representation_data = cap.representation_data ? RepresentationData.fromPrimitive(cap.representation_data) : new RepresentationData()
            }
            return supplier
        }

    async mountEditor(recurring_invoice_id, company_id: Number) {
        // esto ya no hace falta porque he desactivado los botones que requieren de tener contrato de factura electrónica (si ves esto, borralo :) ) 
        // let has_contract = await this.invoiceable_repository.company_has_active_einvoice_contract(company_id)
        // if (!has_contract) {
        //     return false
        // }
        let hasActiveContract = await this.invoiceable_repository.company_has_active_einvoice_contract(company_id)
        this.screen_data.hasActiveContract = hasActiveContract;
        let product_configuration = await this.product_config_repo.get_by_company(company_id)
        this.screen_data.setProductConfiguration(product_configuration)
        let products = await this.product_repository.getProductList(company_id, {})
        this.screen_data.setProducts(products)
        let configuration = await this.config_repo.get_configuration(company_id, 'invoice')
        this.screen_data.setCongiguration(configuration)
        let tax_type = this.screen_data.invoiceConfiguration?.tax_type ? this.screen_data.invoiceConfiguration.tax_type : 'iva'
        let recurring_invoice = this.recurring_invoice_repository.createEmptyRecurringInvoice(company_id, this.currentCompany, tax_type)
        if (recurring_invoice_id){
            recurring_invoice = await this.recurring_invoice_repository.find_by_id(recurring_invoice_id)
            if (!recurring_invoice) {
                return false
            } else {
                if (recurring_invoice.state == 'not_started') {
                    let supplier = this.supplier_from_current_company(this.currentCompany, company_id)
                    recurring_invoice.invoice.supplier = supplier
                    this.recurring_invoice_repository.save(recurring_invoice)
                }
            }
            await this.updateNextInvoiceInfo(recurring_invoice_id, recurring_invoice.interval, recurring_invoice.start_date)
        }
        if (recurring_invoice.invoice.sequence_id) {
            let sequence = this.screen_data.availableSequences.find(seq => seq.id == recurring_invoice.invoice.sequence_id)
            if (sequence) {
                this.screen_data.setSequence(sequence)
            }
        }
        this.screen_data.setRecurringInvoice(recurring_invoice)
        await this.uploadCustomers('')
        return true
    }

    async uploadCustomers(search_term: string) {
        let customer = await this.invoiceable_repository.get_customer_list(this.screen_data.recurringInvoice.invoice.company_id, search_term)
        this.screen_data.setCustomers(customer)
    }

    async saveRecurringInvoice() {
        this.screen_data.setLoading(true)
        let id = await this.recurring_invoice_repository.save(this.screen_data.recurringInvoice)
        if (id){
            let recurringInvoice = await this.recurring_invoice_repository.find_by_id(id)
            this.screen_data.setRecurringInvoice(recurringInvoice)
            this.screen_data.successMessage('Contrato guardado')
            await this.updateNextInvoiceInfo(id, recurringInvoice.interval, recurringInvoice.start_date)
        }
        else {
            this.screen_data.errorMessage('Error al guardar el contrato')
        }
        this.screen_data.setLoading(false)
    }

    addLine() {
        let default_tax = 0.21
        let tax_type = this.screen_data.invoiceConfiguration.tax_type? this.screen_data.invoiceConfiguration.tax_type : 'iva'
        if(!tax_type.includes('iva') && tax_type.includes('igic')){
            default_tax = 0.07
        }
        let line = new InvoiceLine({
            description: '',
            quantity: 0,
            unit_price_without_tax: 0,
            total_cost: 0,
            gross_amount: 0,
            taxes: [new Tax(default_tax, 0, 0)],
            selected_tax: default_tax
        })
        let lines = this.screen_data.recurringInvoice.invoice.lines
        lines.push(line)
        this.screen_data.setLines(lines)
    }

    deleteLine(index) {
        let lines = this.screen_data.recurringInvoice.invoice.lines
        lines.splice(index, 1)
        this.screen_data.setLines(lines)
    }

    async deleteAllLines() {
        let ok = await this.screen_data.deleteAllLinesDialog()
        if (ok){
            this.screen_data.setLoading(true)
            this.screen_data.recurringInvoice.invoice.lines = []
            this.updateInvoice()
        }
        this.screen_data.setLoading(false)
    }

    updateInvoice() {
        const default_reasons= [
        'Operación exenta de IGIC en virtud del Art. 50 de la Ley 4/2012.',
        'Operación exenta de IGIC en virtud del Art. 11 de la Ley 20/1991.',
        'Operación exenta de IGIC en virtud del Art. 12 de la Ley 20/1991.',
        'Operación exenta de IGIC en virtud del Art. 13 de la Ley 20/1991.',
        'Operación exenta de IGIC en virtud del Art. 25 de la Ley 19/1994.',
        'Operación exenta de IGIC en virtud del Art. 47 de la Ley 19/1994.',
        'Operación exenta de IGIC en virtud del Art. 110 de la Ley 4/2012.',
        'Operación exenta de IGIC.',
        'Inversión del sujeto pasivo en virtud del art 84.Uno de la Ley 37/1992, del IVA.',
        'Operación no sujeta a IVA en virtud del art. 7 de la Ley 37/1992, del IVA.',
        'Operación exenta en virtud del art. 20 de la Ley 37/1992, del IVA.',
        'Entrega intracomunitaria exenta en virtud del art. 25 de la Ley 37/1992, del IVA.',
        'Operación exenta por exportación en virtud del art. 21 de la Ley 37/1992, del IVA.',null,'', undefined]
        let reason = ''
        for(let line of this.screen_data.recurringInvoice.invoice.lines){
            if(line.taxes[0].rate == 0.0){
                // console.log(line)
                reason = line.special_taxable_event? line.special_taxable_event['reason'] : ''
                break
            }
        }
        this.screen_data.recurringInvoice.invoice.additional_info = this.screen_data.recurringInvoice.invoice.additional_info? this.screen_data.recurringInvoice.invoice.additional_info : ''
        if (default_reasons.some(default_reason => this.screen_data.recurringInvoice.invoice.additional_info.includes(default_reason))){ // replaceable observaciones (solo si es 0)
            for (let default_reason of default_reasons) {
                if (this.screen_data.recurringInvoice.invoice.additional_info.includes(default_reason)) {
                    if ([null, '', undefined].includes(default_reason) && this.screen_data.recurringInvoice.invoice.additional_info.length > 0) {
                        if (!this.screen_data.recurringInvoice.invoice.additional_info.endsWith('\n')) {
                            this.screen_data.recurringInvoice.invoice.additional_info += '\n';
                        }
                        this.screen_data.recurringInvoice.invoice.additional_info += reason;
                    } else {
                        this.screen_data.recurringInvoice.invoice.additional_info = this.screen_data.recurringInvoice.invoice.additional_info.replace(default_reason, reason);
                    }
                    break;
                }
            }
        }
        this.screen_data.recurringInvoice.compute()
    }

    updateInvoiceLine(index:number){
        let line = this.screen_data.recurringInvoice.invoice.lines[index]
        if (line) {
            let updated_line = line.updateLine()
            let lines = this.screen_data.recurringInvoice.invoice.lines
            lines[index] = updated_line
            this.screen_data.setLines(lines)
        }
    } 

    async importExcelLines(){
        let res = await this.screen_data.askForFile()
        if(res && this.screen_data.file){  
            var file = this.screen_data.file
        }
        else{
            return
        }
        this.screen_data.setLoading(true)
        let path = await this.file_repo.uploadFile(file)
        console.log('saving')
        let my_inv_id = await this.recurring_invoice_repository.save(this.screen_data.recurringInvoice)
        console.log('got_id', this.screen_data.recurringInvoice.invoice.id)
        let res_file  = await this.invoiceable_repository.import_lines_from_excel(this.screen_data.recurringInvoice.invoice.id, path)
        if (res_file && res_file.output['success'] == 'ok') {
            this.screen_data.successMessage('Lineas importadas correctamente')
        } else {
            let error = res_file && res_file.output['error_msg'] ? res_file.output['error_msg'] : ''
            if (error) {
                this.screen_data.error_excel_message = error
            }
            this.screen_data.setErrorExcelDialog(true)
        }
        let inv = await this.recurring_invoice_repository.find_by_id(my_inv_id)
        this.screen_data.setRecurringInvoice(inv)
        this.screen_data.file = null
        this.screen_data.setLoading(false)
    }

    async saveThirdParty(third) {
        let res = await this.invoiceable_repository.save_third(third)
        if (res.status == 'ok') {
            this.screen_data.successMessage('Tercero guardado correctamente')
            let filter_by = ''
            if (third.type == 'juridica') {
                filter_by = third.business_name
            } else {
                filter_by = third.first_surname + ' ' + third.second_surname + ', ' + third.name
            }
            await this.uploadCustomers(filter_by)
            if ([0, -1].includes(this.screen_data.recurringInvoice.invoice.customer.id)) {
                if (res.message['id']) {
                    let third = this.screen_data.customers.find(c => c.id == res.message['id'])
                    this.screen_data.recurringInvoice.invoice.customer = third
                }
            } else {
                this.screen_data.recurringInvoice.invoice.customer = third
            }
            return true
        } else {
            if (res.message == 'Third CIF already exists') {
                this.screen_data.errorMessage('El CIF ya existe')
            }
            else {
                this.screen_data.errorMessage('Error guardando tercero')
            }
            return false
        }
    }

    sequenceChanged() {
        let seq = this.screen_data.availableSequences.find(s => s.id == this.screen_data.recurringInvoice.invoice.sequence_id)
        if (seq) {
            this.screen_data.setSequence(seq)
        }
    }

    async startStopContract(start:boolean) {
        this.screen_data.setLoading(true)
        await this.recurring_invoice_repository.startStopRecurringInvoice(this.screen_data.recurringInvoice.id, start)
        let inv = await this.recurring_invoice_repository.find_by_id(this.screen_data.recurringInvoice.id)
        this.screen_data.setRecurringInvoice(inv)
        this.screen_data.setLoading(false)
    }

    async updateNextInvoiceInfo(recurring_invoice_id, interval, start_date) {
        let info = await this.recurring_invoice_repository.getNextInvoiceInfo(recurring_invoice_id, interval, start_date)
        this.screen_data.nextInvoiceInfo = info
    }

    async getRelatedInvoices() {
        this.screen_data.loadingRelatedInvoices = true
        for (let id of this.screen_data.recurringInvoice.invoice.related_invoiceable_ids) {
            let related = await this.invoiceable_repository.find_by_id(id)
            if (related && !this.screen_data.relatedInvoices.some(inv => inv.id === related.id)) {
                this.screen_data.relatedInvoices.push(related)
            }
        }
        this.screen_data.realtedInvoicesPopup = true
        this.screen_data.loadingRelatedInvoices = false
    }

}